<div class="card border-0 shadow-sm">
  <div class="card-body p-4">
    <div class="d-flex justify-content-between align-items-start gap-2 mb-3">
      <div>
        <div class="fw-bold">Immediate Country Change</div>
        <div class="text-muted small">
          Apply a direct compliance/admin country switch for this user
        </div>
      </div>

      <span *ngIf="currentCountryCode" class="badge text-bg-light border">
        Current: {{ currentCountryCode }}
      </span>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mb-3">
        <label class="form-label small text-muted">New Country Code</label>
        <select class="form-select"
            [class.is-invalid]="submitted && f['countryCode'].invalid"
            formControlName="countryCode">
            <option value="">Select country</option>
            <option *ngFor="let country of countries"
                [value]="country.code">
                {{ country.name }} ({{ country.code }})
            </option>
        </select>
        <div class="invalid-feedback">
          Country code is required
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label small text-muted">Reason</label>
        <textarea
          rows="3"
          class="form-control"
          [class.is-invalid]="submitted && f['reason'].invalid"
          formControlName="reason"
          placeholder="Why is this change being applied immediately?"></textarea>
        <div class="invalid-feedback">
          Reason is required
        </div>
      </div>

      <div class="d-grid">
        <button type="submit" class="btn btn-primary btn-sm" [disabled]="saving">
          <span *ngIf="!saving">Apply Country Change</span>
          <span *ngIf="saving">Applying...</span>
        </button>
      </div>
    </form>
  </div>
</div>